import { useState, useEffect } from "react";
import AxiosInstance from "../../utils/axiosInstance";
import { handleAuth } from "../Login/Auth";
import { useLocation, useNavigate } from "react-router-dom";
import sendToast from "../Toast/sendToast";

const useCountNotifications = () => {
  const [notifications, setNotifications] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTokenData = async () => {
      try {
        const res = await handleAuth(navigate, location);
        // For SuperAdmin, CompanyId might be null, but we still want to fetch notifications
        // Check if user is authenticated (has token data)
        setIsAuthenticated(!!res?.data);
      } catch (error) {
        console.error("Error fetching token data:", error);
        setIsAuthenticated(false);
      }
    };

    fetchTokenData();
  }, [navigate, location]);

  useEffect(() => {
    if (isAuthenticated) {
      const fetchNotifications = async () => {
        try {
          const response = await AxiosInstance.get(`/v1/notification`);
          if (response?.status === 200) {
            setNotifications(response?.data?.count || 0);
          }
        } catch (error) {
          if(error?.response?.status === 401)
          {
            sendToast(error?.response?.data?.error);
          }
          else
          {
            // Don't show error toast for SuperAdmin without CompanyId
            if (error?.response?.status !== 404) {
              sendToast("Unable to connect to the server. Please try again later.");
            }
          }
        }
      };

      // Fetch notifications once when authenticated
      fetchNotifications();
      
      // Removed polling - no automatic refresh every 10 seconds
      // const intervalId = setInterval(() => {
      //   fetchNotifications();
      // }, 10000);

      // return () => clearInterval(intervalId);
    }
  }, [isAuthenticated, navigate]);

  return notifications;
};

export default useCountNotifications;
